import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/zeit/3f757860/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ComponentDemo = makeShortcode("ComponentDemo");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`Default`}</h2>
    <ComponentDemo knobs={{
      DatePicker: ['light']
    }} links={{
      React: 'https://react.carbondesignsystem.com/?path=/story/datepicker--simple',
      Angular: 'https://angular.carbondesignsystem.com/?path=/story/components-date-picker--simple',
      Vue: 'http://vue.carbondesignsystem.com/?path=/story/components-cvdatepicker--default',
      Vanilla: 'https://the-carbon-components.netlify.com/?nav=date-picker'
    }} mdxType="ComponentDemo">{`<DatePicker dateFormat="m/d/Y" datePickerType="simple">
  <DatePickerInput
    id="date-picker-default-id"
    placeholder="mm/dd/yyyy"
    labelText="Date Picker label"
    type="text"
  />
</DatePicker>`}</ComponentDemo>
    <h2>{`Single with calendar`}</h2>
    <ComponentDemo knobs={{
      DatePicker: ['light']
    }} links={{
      React: 'https://react.carbondesignsystem.com/?path=/story/datepicker--single-with-calendar',
      Angular: 'https://angular.carbondesignsystem.com/?path=/story/components-date-picker--single',
      Vue: 'http://vue.carbondesignsystem.com/?path=/story/components-cvdatepicker--single',
      Vanilla: 'https://the-carbon-components.netlify.com/?nav=date-picker'
    }} mdxType="ComponentDemo">{`<DatePicker dateFormat="m/d/Y" datePickerType="single">
  <DatePickerInput
    id="date-picker-calendar-id"
    placeholder="mm/dd/yyyy"
    labelText="Date Picker label"
    type="text"
  />
</DatePicker>`}</ComponentDemo>
    <h2>{`Range with calendar`}</h2>
    <ComponentDemo knobs={{
      DatePicker: ['light']
    }} links={{
      React: 'https://react.carbondesignsystem.com/?path=/story/datepicker--range-with-calendar',
      Angular: 'https://angular.carbondesignsystem.com/?path=/story/components-date-picker--range',
      Vue: 'http://vue.carbondesignsystem.com/?path=/story/components-cvdatepicker--range',
      Vanilla: 'https://the-carbon-components.netlify.com/?nav=date-picker'
    }} mdxType="ComponentDemo">{`<DatePicker dateFormat="m/d/Y" datePickerType="range">
  <DatePickerInput
    id="date-picker-range-start"
    placeholder="mm/dd/yyyy"
    labelText="Date Picker label"
    type="text"
  />
  <DatePickerInput
    id="date-picker-range-end"
    placeholder="mm/dd/yyyy"
    labelText="Date Picker label"
    type="text"
  />
</DatePicker>`}</ComponentDemo>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      